import { render, staticRenderFns } from "./hotSaleCourse.vue?vue&type=template&id=17463352&scoped=true&"
import script from "./hotSaleCourse.vue?vue&type=script&lang=js&"
export * from "./hotSaleCourse.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleCourse.vue?vue&type=style&index=0&id=17463352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17463352",
  null
  
)

export default component.exports